import { Permissions, security } from "Common/permissions";
import { PageObject, ROUTE_ANCHOR, registerRouting } from "Common/routingUtils";
import ActionLog from "./actionLog";
import Connections from "./connections";
import PasswordPolicy from "./passwordPolicy";
import Roles from "./roles";
import Billing from "./billing";
import hashes from "./routesMap.hash";
import locale from "./routesMap.locale";
import routingKeys from "./routingKeys";
import TableMethods from "./tableMethods";
import TaskStatistics from "./taskStatistics";
import Users from "./users";
if (security.isAllowed([Permissions.UsersView])) {
    registerRouting(routingKeys.USERS, new PageObject(Users, {
        hash: hashes.USERS,
        locale: locale.USERS
    }, null, true, () => `${ROUTE_ANCHOR}${hashes.USERS}`));
}
if (security.isAllowed([Permissions.SettingsView])) {
    registerRouting(routingKeys.CONNECTIONS, new PageObject(Connections, {
        hash: hashes.CONNECTIONS,
        locale: locale.CONNECTIONS
    }, null, true, () => `${ROUTE_ANCHOR}${hashes.CONNECTIONS}`));
}
registerRouting(routingKeys.ACTION_LOG, new PageObject(ActionLog, {
    hash: hashes.ACTION_LOG,
    locale: locale.ACTION_LOG
}, null, true, () => `${ROUTE_ANCHOR}${hashes.ACTION_LOG}`));
if (security.isAllowed([Permissions.TasksView])) {
    registerRouting(routingKeys.TASK_STATISTICS, new PageObject(TaskStatistics, {
        hash: hashes.TASK_STATISTICS,
        locale: locale.TASK_STATISTICS
    }, null, true, () => `${ROUTE_ANCHOR}${hashes.TASK_STATISTICS}`));
}
if (security.isAllowed([Permissions.RolesView])) {
    registerRouting(routingKeys.ROLES, new PageObject(Roles, {
        hash: hashes.ROLES,
        locale: locale.ROLES
    }, null, true, () => `${ROUTE_ANCHOR}${hashes.ROLES}`));
}
registerRouting(routingKeys.METHODS, new PageObject(TableMethods, {
    hash: hashes.METHODS,
    locale: locale.METHODS
}, null, true, () => `${ROUTE_ANCHOR}${hashes.METHODS}`));
registerRouting(routingKeys.BILLING, new PageObject(Billing, {
    hash: hashes.BILLING,
    locale: locale.BILLING
}, null, true, () => `${ROUTE_ANCHOR}${hashes.BILLING}`));
if (security.isAllowed([Permissions.PasswordPolicyView])) {
    registerRouting(routingKeys.PASSWORD_POLICY, new PageObject(PasswordPolicy, {
        hash: hashes.PASSWORD_POLICY,
        locale: locale.PASSWORD_POLICY
    }, null, true, () => `${ROUTE_ANCHOR}${hashes.PASSWORD_POLICY}`));
}
